import { Component, ViewChild } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { GenericTableComponent } from 'src/app/features/shared/features/generic-table/components/generic-table.component';
import { CatalogPaginationRequest } from 'src/app/features/shared/models/CatalogPagination/CatalogPaginationRequest';
import { FilterRequest } from 'src/app/features/shared/models/Filter/FilterRequest';
import { SystemAlarmsCatalogKeys } from '../../models/SystemAlarmsCatalogKeys copy';
import { SystemAlarmService } from '../../service/SystemAlarm.service';

@Component({
  selector: 'system-alarmsPage',
  templateUrl: './system-alarmsPage.component.html',
  styleUrls: ['./system-alarmsPage.component.css']
})
export class SystemAlarmsPageComponent {

  
}
